import styled from 'styled-components'

export const PageTitleNote = styled.p`
  color: ${({ theme }) => theme.text1};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0 0 20px;
  text-align: left;
`
